module.exports = __webpack_public_path__ + "img/welcome0.9f029fe2.jpg";